import React, {Component} from 'react';
import { useState, useEffect } from 'react';
import {Animated} from "react-animated-css";
import { Card, Row, Col, Container, ListGroup,Button,Image, Modal,Carousel } from "react-bootstrap";
import courseImg from "../../../assets/course_img/default_course_cover.png";
import Loader from '../../blocks/Loader';
import {pageLoadManageActions as loader} from "../../../reducers/load";
import DemoQuestionViewer from '../../screens/demoQuestions/DemoQuestionViewer';
import { faCircleCheck,faClockFour, faVideo,faQuestionCircle , faBook , faGears } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FileViewer from 'react-file-viewer';
import ReactPlayer from "react-player";

export default function TopicFlowViewer(props) {
    const topic = props.topic;
    const currentFlow = props.flow;
    const [targetSlideIndex, setTargetSlide] = React.useState(0);
    const [isVisible, setIsVisible] = React.useState(true);
    useEffect(()=>{
    
        if(!currentFlow){
            console.log('start Loader');
           // loader.start("El-demo-topic-view");    
        }else{
            console.log('stop Loader');
           // loader.stop("El-demo-topic-view");
        }
    },[props.flow])    
    if(topic){     
        const getTargetSlide = (step)=>{
            switch(step.name)
                {
                    case 'question':
                        return <DemoQuestionViewer {...props} step={step} question = {step.data.question} answers={step.data.answers}/>                                            
                        break;
                    default:                                    
                        let fileType = step.data.file_type?.split('/')[1];
                        let url =step.data?.url || ''; 
                        let viewType = step.params?.view_type;                                        
                        return (<div className="Material-FileViewer text-center" style={{display: "flex",justifyContent: "center"}}>
                                    {step.name === "document"
                                        ? viewType === "presentation"
                                            ? <Presentation url={url} t={props.t} handleWatched={()=>{}} onError={()=>{}} />
                                            : <div id="FileViewer">
                                                <FileViewer
                                                    autoPlay={false}
                                                    fileType={fileType}
                                                    filePath={url}
                                                    errorComponent={<></>}
                                                    onError={()=>{}} />
                                            </div>
                                        : <ReactPlayer
                                            id="FileViewer"
                                            playing={false}
                                            url={url}
                                            width="100%"
                                            style={{maxWidth:'80vw'}}
                                            height="100%"
                                            onError={()=>{}}
                                            controls //={devMode}
                                            config={{ file: { attributes: { controlsList: 'nodownload', disablePictureInPicture: true } } }} />}
                                </div>)
                        break;
                }
        }
        return( 
        <Modal
            show={props.show}
            style={{minWidth:"80vw"}}
            size="lg"            
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide = {props.onHide}
            className= {"topicFlowModal"}            
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {topic.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>                 
                    {currentFlow?<div>                    
                            {getTargetSlide(currentFlow.steps[targetSlideIndex])}                    
                            <div style={{ display:"flex",  flexWrap: "nowrap",  justifyContent: "center"}}>                            
                                {Array.prototype.map.call(currentFlow.steps, function(step,index){
                                    let stepIcon = "";
                                    switch(step.name)
                                    {
                                        case 'question':
                                            stepIcon = faQuestionCircle;
                                            break;
                                        case 'video':
                                            stepIcon = faVideo;
                                            break;
                                        case 'document':
                                            stepIcon = faBook
                                            break;
                                        case 'vr':
                                            stepIcon = faGears;
                                            break;
                                    }
                                    return  <Button style={{borderRadius:"0",backgroundColor:"#1E874A", borderColor:"#1E874A"}} variant={'info'} key={index} className={ (index == targetSlideIndex)?"mr-1 active":"mr-1"} onClick={()=>{setTargetSlide(index)}} title={props.t("Move to")+" "+step.title}># {index+1} <FontAwesomeIcon title={props.t(step.title)} icon={stepIcon}/></Button>                                                       
                                })}
                            </div>
                        </div>
                        :<div style={{ marginTop:"50px",marginBottom:"50px",display:"flex",  flexWrap: "nowrap",  justifyContent: "center"}}><h2>{props.t("Load steps content")}...</h2></div>
                       }
                     
            </Modal.Body>
        </Modal>
        );
    }else{
        return (<><p>Загрузка....</p></>)
    }
}